import { lazyLoad } from "utils/loadable";

export const AdminJobDetails = lazyLoad(
  () => import("./index"),
  (module) => module.AdminJobViewDetails
);
